module.exports = __webpack_public_path__ + "img/Allihoopa.4ba55e1e.png";